import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import noTasks from '../../../assets/img/noTasks.png';
import COLORS from '../../../common/data/enumColors';
import { convertIMG, convertURL, getReportPlanning } from '../../../common/function/functionsUtils';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import AuthContext from '../../../contexts/authContext';
import { DevisLinesContextProvider } from '../../../contexts/devisLinesContext';
import { MailMessageContextProvider } from '../../../contexts/mailMessageContext';
import useDarkMode from '../../../hooks/useDarkMode';
import { searchFactures, updateFacture } from '../../../odooApi/accountMove';
import searchDevis, { createDevis } from '../../../odooApi/devis';
import { deleteImageAPI } from '../../../odooApi/imagesApi';
import {
	getSinglePlanning,
	updateSlotPlanning,
	uploadAttachementsCommercial,
	uploadAttachementsSuppTechnicien,
	uploadAttachementsTechnicien,
} from '../../../odooApi/planningSlot';
import { getAttachment } from '../../../odooApi/voiture';
import NavigatePopup from '../../Achats/Appel/navigatePopup';
import ActivityCreatePopup from '../../Activity/ActivityCreatePopup';
import Attachements from '../../Attachements/Attachements';
import SearchClient from '../../Clients/SearchClient';
import DechargeDevis from '../../Devis/DechargeDevis';
import DevisCard from '../../Devis/DevisCard';
import DevisPopUp from '../../Devis/DevisPopUp';
import FactureCard from '../../Facturation/FactureCard';
import PaymentPopup from '../../Facturation/PaymentPopup';
import Alert from '../../bootstrap/Alert';
import Button from '../../bootstrap/Button';
import Card, {
	CardActions,
	CardBody,
	CardFooter,
	CardFooterRight,
	CardHeader,
	CardLabel,
	CardTabItem,
	CardTitle,
} from '../../bootstrap/Card';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../bootstrap/Dropdown';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';
import Label from '../../bootstrap/forms/Label';
import Textarea from '../../bootstrap/forms/Textarea';
import useOutsideClick from '../../customComponents/SearchAutoComplete/useOutsideClick';
import ErrorPopup from '../../extras/ErrorPopup';
import showNotification from '../../extras/showNotification';
import Icon from '../../icon/Icon';
import ConfirmationPopup from '../ConfirmationPopup';
import StatusPopup from '../StatusPopup';
import Chronologies from './Chronologies/Chronologies';
import InterventionCreatePopUp from './InterventionCreatePopUp';
import MotifsRapports from './MotifsRapportIntervention/MotifsRapports';
import PaiementsCard from './PaiementCardTab/PaiementsCard';
import PvReceptionPopup from './PvReceptionPopup';
import VoiturePopup from './VoiturePopup';

const InterventionPopUp = ({ setEditModalStatus, id, getInterventions = () => { } }) => {
	const [activeTabControled, setActiveTabControled] = useState(0);
	const { darkModeStatus } = useDarkMode();
	const { userData } = useContext(AuthContext);
	const [event, setEvent] = useState({});
	const [formState, setFormState] = useState({ ...event, paiement: false });
	const [searchModalStatus, setSearchModalStatus] = useState(false);
	const [filterResult, setfilterResult] = useState({});
	const [curentInput, setCurentInput] = useState({ inputName: '', inputLabel: '' });
	const [selectedClient, setSelectedClient] = useState({});
	const [attachmentsRaport, setAttachmentsRaport] = useState(event?.attachment_report);
	const [attachmentsRaportSupp, setAttachmentsRaportSupp] = useState(
		event?.attachment_report_supp,
	);
	const [attachmentsCommercial, setAttachmentsCommercial] = useState(event?.attachment);
	const [selectedVoiture, setSelectedVoiture] = useState({});
	const [editDevisModalStatus, setEditDevisModalStatus] = useState(false);
	const [newDevisData, setNewDevisData] = useState({});
	const [devisDatas, setDevisDatas] = useState([]);
	const [devisAccepte, setDevisAccepte] = useState({});
	const [facturesDatas, setFacturesDatas] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [confirmDeletePopup, setConfirmDeletePopup] = useState(false);
	const [updateIntervention, setUpdateIntervention] = useState(false);
	const [confirmCreateDevisPopup, setConfirmCreateDevisPopup] = useState(false);
	const [confirmCreatePVPopup, setConfirmCreatePVPopup] = useState(false);
	const [updateClientModal, setUpdateClientModal] = useState(false);
	const remarqueRef = useRef();
	const [confirmDecharge, setConfirmDecharge] = useState(false);
	const [uploadSpinner, setUploadSpinner] = useState(false);
	const [uploadPopup, setUploadPopup] = useState(false);
	const [success, setSuccess] = useState(false);
	const [openList, setOpenList] = useState(false);
	const [devisIsLoading, setDevisIsLoading] = useState(false);
	const [filterDevisResult, setFilterDevisResult] = useState({});
	const [devisInputSearch, setDevisInputSearch] = useState('');
	const [nouvelleIntervention, setNouvelleIntervention] = useState(false);
	const [dupliquerIntervention, setDupliquerIntervention] = useState(false);
	const [newData, setNewData] = useState();
	const [dupliquerData, setDupliquerData] = useState();
	const [paymentModalStatus, setPaymentModalStatus] = useState(false);
	const [editModalTask, setEditModalTask] = useState(false);
	const [openSupp, setOpenSupp] = useState(false);
	const [openRapport, setOpenRapport] = useState(false);
	const [stateForm, setStateForm] = useState({});

	const handleClickOutside = () => {
		setOpenList(false);
	};
	const ref = useOutsideClick(handleClickOutside);
	const { t } = useTranslation(['translation', 'menu']);
	const [error, setError] = useState();
	const [obligation, setObligation] = useState(false);
	const [voiturePopup, setVoiturePopup] = useState(false);
	const [userInput, setUserInput] = useState('');
	const [autoGeneratedContent, setAutoGeneratedContent] = useState('');
	const [checkPaiement, setCheckPaiement] = useState(false);
	const [spinner, setSpinner] = useState(false);
	const handleUpdateFacture = (id) => {
		updateFacture(userData?.password, { id: id, pose_fini: true });
	};
	const handelUpdateSuivi = (suivi) => {
		updateSlotPlanning(
			userData?.password,
			{
				id: formState?.id,
				suivi: suivi,
			},
			() => {
				getInterventions();
				setEditModalStatus(false);
				setIsLoading(false);
			},
		);
	};
	const handelUploadRapportSupp = () => {
		setIsLoading(true);
		updateSlotPlanning(
			userData?.password,
			{
				id: formState?.id,
				rapport_supp: formState?.rapport_supp,
			},
			() => {
				getInterventions();
				setEditModalStatus(false);
				setIsLoading(false);
			},
		);
	};
	const handelSubmit = (paiement) => {
		if (
			((userData?.role == 'Technicien' || userData?.role?.toLocaleLowerCase() == 'achat') &&
				formState?.Rapport == '' &&
				Object.keys(stateForm).length === 0) ||
			attachmentsRaport?.length == 0
		) {
			setActiveTabControled(2);
			setObligation('Complétez votre rapport et entrez la liste des pièces jointes !');
		} else if (
			(userData?.role == 'Technicien' ||
				userData?.role?.toLocaleLowerCase() == 'achat' ||
				userData?.role?.toLocaleLowerCase() == 'admin') &&
			!formState?.paiement &&
			!paiement
		) {
			setCheckPaiement(true);
		} else {
			if (
				userData?.role == 'Technicien' ||
				userData?.role?.toLocaleLowerCase() == 'achat' ||
				userData?.role?.toLocaleLowerCase() == 'admin'
			) {
				updateSlotPlanning(
					userData?.password,
					{
						id: formState?.id,
						Rapport: formState?.Rapport,
						state: 'done',
					},
					() => {
						formState?.type_int == 'Pose' &&
							facturesDatas?.length > 0 &&
							facturesDatas?.map((factureId) => {
								handleUpdateFacture(factureId?.id);
							});
						getInterventions();
						setEditModalStatus(false);
					},
				);
			} else {
				if (attachmentsCommercial?.length > 0) {
					setIsLoading(true);
					uploadAttachementsCommercial(
						userData?.password,
						formState?.id,
						attachmentsCommercial,
						() => {
							getInterventions();
							setEditModalStatus(false);
							setIsLoading(false);
							showNotification(
								<span className='d-flex align-items-center'>
									<Icon icon='Info' size='lg' className='me-1' />
									<span>Mise à jour avec succès</span>
								</span>,
								'La mise à jour a été créé avec succès',
							);
						},
					);
				}
				// if (selectedVoiture?.name) {
				// 	setIsLoading(true);
				// 	updateSlotPlanning(
				// 		userData?.password,
				// 		{
				// 			id: formState?.id,
				// 			voiture: selectedVoiture?.id,
				// 		},
				// 		() => {
				// 			getInterventions();
				// 			setEditModalStatus(false);
				// 			setIsLoading(false);
				// 			showNotification(
				// 				<span className='d-flex align-items-center'>
				// 					<Icon icon='Info' size='lg' className='me-1' />
				// 					<span>Mise à jour avec succès</span>
				// 				</span>,
				// 				'La mise à jour a été créé avec succès',
				// 			);
				// 		},
				// 	);
				// }
			}
		}
	};
	const handleDevisChange = (e) => {
		setOpenList(true);
		setDevisInputSearch(e?.target?.value);
	};
	const handelSelectDevis = (item) => {
		setOpenList(false);
		const exist = !!formState?.devis_liste.find((id) => id == item?.id);
		if (!exist) {
			formState.devis_liste = [...formState?.devis_liste, item?.id];
		}
		setFilterDevisResult([]);
	};
	const handleChange = (e) => {
		setFormState({ ...formState, [e.target.name]: e.target.value });
		if (e.target.name == 'nom_client') {
			setSearchModalStatus(true);
			setCurentInput({ inputName: e.target.name, inputLabel: 'Clients' });
		} else if (e.target.name == 'voiture') {
			setSearchModalStatus(true);
			setCurentInput({ inputName: e.target.name, inputLabel: 'voitures' });
		} else {
			setCurentInput({ inputName: [e.target.name] });
		}
	};

	const handleUpdate = (result) => {
		formState.partner_id = result;
	};

	const handelSelect = ({ value, selected }) => {
		if (!!selected?.nom_client) {
			setSelectedClient({ ...selected?.nom_client });
			setFormState({ ...formState, ...value });
		}
		if (!!selected?.voiture) {
			setSelectedVoiture({ ...selected?.voiture });
			setFormState({ ...formState, ...value });
		}
		setSearchModalStatus(false);
	};

	/** delete images report */
	const deleteRaportImage = (key, file) => {
		if (!!file?.id) {
			deleteImageAPI(
				userData?.password,
				file?.id,
				() => { },
				(error) => {
					setError(error);
				},
			);
		}
		const updatedImages = attachmentsRaport.filter((item, index) => index != key);
		setAttachmentsRaport(updatedImages);
		event.attachment_report = updatedImages;
	};

	/** delete images report */
	const deleteRaportImageSupp = (key, file) => {
		if (!!file?.id) {
			deleteImageAPI(
				userData?.password,
				file?.id,
				() => { },
				(error) => {
					setError(error);
				},
			);
		}
		const updatedImages = attachmentsRaportSupp.filter((item, index) => index != key);
		setAttachmentsRaport(updatedImages);
		event.attachment_report_supp = updatedImages;
	};

	const deleteCommercialImage = (key, file) => {
		if (!!file?.id) {
			deleteImageAPI(
				userData?.password,
				file?.id,
				() => { },
				(error) => {
					setError(error);
				},
			);
		}
		const updatedImages = attachmentsCommercial.filter((item, index) => index != key);
		setAttachmentsCommercial(updatedImages);
		event.attachment = updatedImages;
	};

	const handelUpdateIntervention = () => {
		const employees = [];
		formState?.voitures?.length > 0
			? formState?.voitures?.map((voiture) => {
				voiture?.conducteur?.map((technicien) => {
					employees.push(technicien?.id);
				});
			})
			: formState?.voiture?.conducteur?.map((technicien) => {
				employees.push(technicien?.id);
			});
		const updatePlanning = {
			id: formState?.id,
			start_datetime: moment(formState?.start_datetime).format('YYYY-MM-DD HH:mm:ss'),
			end_datetime: moment(formState?.end_datetime).format('YYYY-MM-DD HH:mm:ss'),
			voitures: formState?.voitures?.map((v) => v?.id),
			Remarque: formState?.Remarque || '',
			employees_ids: employees,
			devis_liste: formState?.devis_liste,
			partner_id: formState?.partner_id?.id,
			amount_residual: formState?.amount_residual,
			company_id: formState?.voitures[0]?.conducteur[0]?.company_id,
		};
		setIsLoading(true);

		updateSlotPlanning(
			userData?.password,
			updatePlanning,
			() => {
				if (attachmentsCommercial?.length > 0) {
					uploadAttachementsCommercial(
						userData?.password,
						formState?.id,
						attachmentsCommercial,
						() => {
							getInterventions(null);
							setIsLoading(false);
							setSuccess('Intervention modifiée avec succès.');
						},
						(error) => {
							setError(error);
							setIsLoading(false);
						},
					);
				} else {
					setIsLoading(false);
					setSuccess('Intervention modifiée avec succès.');
				}
			},
			(error) => {
				setError(error);
				setIsLoading(false);
			},
		);
	};

	/** Annuler l'intervention */
	const handleDeleteIntervention = () => {
		if (userData && userData?.id && userData?.password) {
			if (formState?.state != 'cancel') {
				updateSlotPlanning(
					userData?.password,
					{
						id: formState?.id,
						state: 'cancel',
					},
					() => {
						getInterventions();
						setEditModalStatus(false);
					},
				);
			} else {
				//getInterventions();
				setEditModalStatus(false);
			}
		}
	};

	/** Créer un devis */
	const handleCreateDevis = () => {
		if (userData && userData?.id && userData?.password) {
			const newDevis = {
				project_title:
					'Devis ' +
					formState?.motif +
					' ' +
					formState?.partner_id?.name +
					' ' +
					formState?.name_seq,
				partner_id: formState?.partner_id?.id,
				ref_intervention: formState?.name_seq,
				planning_id: formState?.id,
				responsable_intervention: formState?.login_user?.id,
				//company_id: event?.company_id,
				techniciens: formState?.employees_ids?.map((item) => item?.id),
			};
			createDevis(
				userData?.password,
				newDevis,
				(devisData) => {
					updateSlotPlanning(
						userData?.password,
						{
							id: formState?.id,
							devis_liste: [...formState?.devis_liste, devisData?.id],
						},
						() => {
							// (event.devis_liste = [...formState?.devis_liste, devisData?.id]),
							setNewDevisData(devisData);
							setFormState((prev) => ({
								...prev,
								devis_liste: [...prev?.devis_liste, devisData?.id],
							}));

							setEditDevisModalStatus(true);
						},
						(error) => {
							setError(error);
						},
					);
				},
				(error) => {
					setError(error);
				},
			);
		}
	};

	const loadDevis = () => {
		searchDevis(userData?.password, [['id', 'in', formState?.devis_liste]], ({ elements }) => {
			setDevisDatas(elements);
			event.devis_liste = formState?.devis_liste;
			setDevisAccepte(elements?.find((i) => i.state == 'done'));
			elements?.map((devis) => {
				!!devis?.invoice_id &&
					searchFactures(
						userData?.password,
						[['id', '=', devis?.invoice_id]],
						(result) => {
							result?.elements?.length > 0 &&
								//setFacturesDatas([...facturesDatas, result.elements[0]]);
								setFacturesDatas(
									!!facturesDatas.filter(
										(facture) => facture.id == result.elements[0].id,
									)?.length
										? facturesDatas
										: [...facturesDatas, result.elements[0]],
								);
						},
					);
			});
		});
	};

	useEffect(() => {
		let info = [];

		if (event?.attachment?.length > 0) {
			event?.attachment?.map((data) => {
				if (data?.mimetype == 'application/pdf') {
					convertURL(
						getAttachment(userData?.password, data?.id),
						'intervention_' + event?.name_seq,
						(file) => {
							info.push(file);
						},
						(error) => {
							console.error('Erreur :', error);
						},
					);
				} else {
					convertIMG(
						getAttachment(userData?.password, data?.id),
						'intervention_' + event?.name_seq,
						(file) => {
							info.push(file);
						},
						(error) => {
							console.error('Erreur :', error);
						},
					);
				}
			});
		}

		if (event?.attachment_report?.length > 0) {
			event?.attachment_report?.map((data) => {
				if (data?.mimetype == 'application/pdf') {
					convertURL(
						getAttachment(userData?.password, data?.id),
						'intervention_' + event?.name_seq,
						(file) => {
							info.push(file);
						},
						(error) => {
							console.error('Erreur :', error);
						},
					);
				} else {
					convertIMG(
						getAttachment(userData?.password, data?.id),
						'intervention_' + event?.name_seq,
						(file) => {
							info.push(file);
						},
						(error) => {
							console.error('Erreur :', error);
						},
					);
				}
			});
		}
		convertURL(
			getReportPlanning(userData, id),
			'Rapport_intervention_' + event?.name_seq,
			(file) => {
				info.push(file);
			},
			(error) => {
				console.error('Erreur :', error);
			},
		);

		const dupliquerEvent = {
			parent_id: event?.id,
			seq: event?.name_seq,
			type_int: event?.type_int,
			partner_id: formState?.partner_id?.id,
			client: event?.partner_id?.name,
			clientData: event?.partner_id,
			start_datetime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
			end_datetime: moment(new Date()).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
			voitures: event?.voitures,
			motif: event?.motif,
			login_user: userData?.id,
			attachmentsCommercial: info,
			devis_liste: event?.devis_liste,
			Remarque: !!event?.Remarque
				? event?.Remarque.replace(/<br\s*\/?>/g, '\n').replace(/<\/?[^>]+(>|$)/g, '')
				: '',
		};
		const newEvent = {
			client: event?.partner_id?.name,
			clientData: event?.partner_id,
			voitures: event?.voitures,
			start_datetime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
			end_datetime: moment(new Date()).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
		};
		setNewData(newEvent);
		setDupliquerData(dupliquerEvent);
	}, [event]);

	useEffect(() => {
		if (event?.id) {
			if (
				formState?.state == 'draft' &&
				(userData?.role == 'Technicien' || userData?.role?.toLocaleLowerCase() == 'achat')
			) {
				updateSlotPlanning(
					userData?.password,
					{
						id: formState?.id,
						state: 'sale',
						employees_ids: formState?.employees_ids?.map((item) => item?.id),
					},
					() => {
						setFormState({ ...formState, state: 'sale' });
						event.state = 'sale';
					},
				);
			}
		}
	}, [event]);

	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		setSpinner(true);
		getSinglePlanning(
			userData?.password,
			id,
			(result) => {
				setFormState(result);
				setEvent(result);
				setSpinner(false);
				setAttachmentsRaport(result?.attachment_report);
				setAttachmentsCommercial(result?.attachment);
				setAttachmentsRaportSupp(result?.attachment_report_supp);
			},
			(error) => {
				//setSpinner(false);
			},
			signal,
		);
		return () => {
			abortController.abort();
		};
	}, []);

	useEffect(() => {
		formState?.devis_liste?.length > 0 && loadDevis();
	}, [formState?.devis_liste]);

	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		if (devisInputSearch === '') {
			setFilterDevisResult([]);
		} else {
			setDevisIsLoading(true);
			searchDevis(
				userData?.password,
				[
					'|',

					['name', 'ilike', devisInputSearch],

					'|',
					['nom_client', 'ilike', devisInputSearch],

					'|',
					['phone_client', 'ilike', devisInputSearch],

					['mobile_client', 'ilike', devisInputSearch],
				],
				({ elements }) => {
					setFilterDevisResult(elements);
					setDevisIsLoading(false);
				},
				(error) => {
					//setError(error);
					setDevisIsLoading(true);
				},
				signal,
			);
		}
		return () => {
			abortController.abort();
		};
	}, [devisInputSearch]);

	const updateAutoGeneratedContent = useCallback(() => {
		const fields = [
			{ name: 'service', label: 'Service' },
			{ name: 'autre', label: 'Autre' },
			{ name: 'moyen', label: 'Moyen' },
			{ name: 'supp', label: 'Supplémentaire' },
		];

		const content = fields
			.map((field) => {
				const value = stateForm[field.name]?.label || '';
				return stateForm[field.name]?.id ? `${value} ` : '';
			})
			.join('');

		setAutoGeneratedContent(content);
	}, [stateForm.service, stateForm.autre, stateForm.moyen, stateForm.supp]);

	useEffect(() => {
		updateAutoGeneratedContent();
	}, [stateForm.service, stateForm.autre, stateForm?.moyen, updateAutoGeneratedContent]);

	const handleUserInputChange = (e) => {
		setUserInput(e.target.value);
	};

	useEffect(() => {
		// Only concatenate auto-generated content if user hasn't typed anything
		const newRapport = autoGeneratedContent + userInput;
		setFormState((prev) => ({ ...prev, Rapport: newRapport }));
	}, [userInput, autoGeneratedContent]);

	return (
		<>
			<Modal setIsOpen={() => { }} isOpen={true} size='xl' isScrollable classNameMd='nv-2'>
				{!!spinner ? (
					<>
						<ModalHeader
							className='px-4'
							setIsOpen={() => {
								setEditModalStatus(false);
							}}></ModalHeader>
						<ModalBody className='px-4'>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									flexDirection: 'column',
								}}>
								<Spinner color='dark' size={'4rem'} />
								<span className='p-3'>Chargement des données ...</span>
							</div>
						</ModalBody>
					</>
				) : (
					<>
						<ModalHeader
							className='px-4'
							setIsOpen={() => {
								formState?.state == 'draft' &&
									(userData?.role == 'Technicien' ||
										userData?.role?.toLocaleLowerCase() == 'achat') &&
									getInterventions();
								setEditModalStatus(false);
							}}>
							<div className='d-flex justify-content-between w-100'>
								<ModalTitle id='project-edit'>
									{formState?.name_seq + ' - ' + t(formState?.state)}
								</ModalTitle>
								<div className='d-flex me-2'>
									{userData?.role != 'Technicien' &&
										userData?.role?.toLocaleLowerCase() != 'achat' &&
										formState?.type_int == 'Devis' && (
											<Button
												icon='Edit'
												isLight
												color='info'
												className='col-auto me-2'
												onClick={() => {
													setDupliquerData({
														...dupliquerData,
														type_int: 'Pose',
														devis_liste: formState?.devis_liste,
														parent_id: event?.id,
													});
													setDupliquerIntervention(true);
												}}>
												Planifier pose
											</Button>
										)}

									<Dropdown>
										<DropdownToggle>
											<Button color='success' isLight>
												Actions
											</Button>
										</DropdownToggle>
										<DropdownMenu>
											{userData?.role != 'Technicien' &&
												userData?.role?.toLocaleLowerCase() != 'achat' && (
													<>
														<DropdownItem>
															<Button
																icon='AddCircle'
																isLight
																color='success'
																className='w-auto'
																onClick={() =>
																	setDupliquerIntervention(true)
																}>
																Créer nouvelle intervention
															</Button>
														</DropdownItem>
														{/* <DropdownItem>
													<Button
														icon='ControlPointDuplicate'
														isLight
														color='success'
														className='w-auto'
														onClick={() =>
															setDupliquerIntervention(true)
														}>
														Dupliquer
													</Button>
												</DropdownItem> */}
														{event?.suivi == 'Valider' ? (
															<DropdownItem>
																<Button
																	icon='CheckCircle'
																	isLight
																	color='success'
																	className='w-auto'
																	onClick={() =>
																		handelUpdateSuivi(
																			'Dévalider',
																		)
																	}>
																	Dévalider
																</Button>
															</DropdownItem>
														) : (
															<DropdownItem>
																<Button
																	icon='CheckCircle'
																	isLight
																	color='success'
																	className='w-auto'
																	onClick={() =>
																		handelUpdateSuivi('Valider')
																	}>
																	Valider
																</Button>
															</DropdownItem>
														)}

														{formState?.state != 'cancel' && (
															<DropdownItem>
																<Button
																	icon='Cancel'
																	isLight
																	color='success'
																	className='w-auto'
																	onClick={() =>
																		setConfirmDeletePopup(true)
																	}>
																	Annuler
																</Button>
															</DropdownItem>
														)}
													</>
												)}

											<DropdownItem>
												<Button
													icon='AddTask'
													isLight
													color='info'
													className='w-auto'
													onClick={() => setEditModalTask(true)}>
													Créer tâche
												</Button>
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								</div>
							</div>
						</ModalHeader>
						<ModalBody className='px-4'>
							<Card
								hasTab
								shadow={'none'}
								activeTabControled={activeTabControled}
								setActiveTabControled={setActiveTabControled}>
								<CardTabItem id='tab' title='Détails'>
									<div className='row'>
										<div className='col-xl-6 col-md-12'>
											<Card shadow='sm' stretch>
												<CardHeader>
													<CardLabel icon='Info' iconColor='primary'>
														<CardTitle>
															Informations du Client
														</CardTitle>
													</CardLabel>
													<CardActions>
														<Button
															icon='Edit'
															isLight
															color='primary'
															onClick={() =>
																setUpdateClientModal(true)
															}>
															Modifier client
														</Button>
													</CardActions>
												</CardHeader>

												<CardBody>
													<div className='row g-3 '>
														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='Person'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Nom et Prénom
																	</div>
																	<div className='fw-bold'>
																		{
																			formState?.partner_id
																				?.name
																		}
																	</div>
																</div>
															</div>
														</div>

														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='Email'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Adresse mail
																	</div>
																	<div className='fw-bold'>
																		{
																			formState?.partner_id
																				?.email
																		}
																	</div>
																</div>
															</div>
														</div>

														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='AddLocationAlt'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Adresse
																	</div>
																	<div className='fw-bold'>
																		<a
																			target='_blank'
																			href={
																				formState
																					?.partner_id
																					?.places
																			}>
																			{formState?.partner_id
																				?.street +
																				' ' +
																				formState
																					?.partner_id
																					?.city +
																				' ' +
																				formState
																					?.partner_id
																					?.zip}
																		</a>
																	</div>
																</div>
															</div>
														</div>
														{!!formState?.partner_id?.phone && (
															<div className='col-12'>
																<div className='d-flex align-items-center'>
																	<div className='flex-shrink-0'>
																		<Icon
																			icon='PhoneAndroid'
																			size='2x'
																			color='primary'
																		/>
																	</div>
																	<div className='flex-grow-1 ms-3'>
																		<div className='text-muted'>
																			N° Téléphone
																		</div>
																		<div className='fw-bold'>
																			{
																				formState
																					?.partner_id
																					?.phone
																			}
																		</div>
																	</div>
																</div>
															</div>
														)}
														{!!formState?.partner_id?.mobile && (
															<div className='col-12'>
																<div className='d-flex align-items-center'>
																	<div className='flex-shrink-0'>
																		<Icon
																			icon='Phone'
																			size='2x'
																			color='primary'
																		/>
																	</div>
																	<div className='flex-grow-1 ms-3'>
																		<div className='text-muted'>
																			2éme N° Téléphone
																		</div>
																		<div className='fw-bold'>
																			{
																				formState
																					?.partner_id
																					?.mobile
																			}
																		</div>
																	</div>
																</div>
															</div>
														)}

														{!!formState?.partner_id?.x_code && (
															<div className='col-12'>
																<div className='d-flex align-items-center'>
																	<div className='flex-shrink-0'>
																		<Icon
																			icon='DeveloperBoard'
																			size='2x'
																			color='primary'
																		/>
																	</div>
																	<div className='flex-grow-1 ms-3'>
																		<div className='text-muted'>
																			Code d'accès
																		</div>
																		<div className='fw-bold'>
																			{
																				formState
																					?.partner_id
																					?.x_code
																			}
																		</div>
																	</div>
																</div>
															</div>
														)}

														{userData?.role == 'Technicien' ||
															userData?.role?.toLocaleLowerCase() ==
															'achat' ? (
															<>
																{!!formState?.Remarque && (
																	<div className='col-12'>
																		<div className='d-flex'>
																			<div className='flex-shrink-0'>
																				<Icon
																					icon='TextSnippet'
																					size='2x'
																					color='primary'
																				/>
																			</div>

																			<div className='flex-grow-1 ms-3'>
																				<div className='text-muted'>
																					Remarques
																				</div>

																				{React.createElement(
																					'div',
																					{
																						dangerouslySetInnerHTML:
																						{
																							__html: (
																								formState?.Remarque ||
																								''
																							).replace(
																								/\n/g,
																								'<br />',
																							),
																						},
																					},
																				)}
																			</div>
																		</div>
																	</div>
																)}
																{!!formState?.amount_residual && (
																	<div className='col-12'>
																		<div className='d-flex'>
																			<div className='flex-shrink-0'>
																				<Icon
																					icon='Euro'
																					size='2x'
																					color='primary'
																				/>
																			</div>

																			<div className='flex-grow-1 ms-3'>
																				<div className='text-muted'>
																					Le client doit
																					payer :
																				</div>
																				<span className='bold'>
																					{
																						formState?.amount_residual
																					}{' '}
																					€
																				</span>
																			</div>
																		</div>
																	</div>
																)}
															</>
														) : (
															<>
																<div className='col-12'>
																	<div className='d-flex'>
																		<div className='flex-shrink-0'>
																			<Icon
																				icon='TextSnippet'
																				size='2x'
																				color='primary'
																			/>
																		</div>

																		<div className='flex-grow-1 ms-3'>
																			<div className='text-muted'>
																				Remarques
																			</div>
																			<FormGroup
																				className='col-12'
																				id='remarque'>
																				<Textarea
																					name='Remarque'
																					id='Remarque'
																					value={formState?.Remarque?.replace(
																						/<br\s*\/?>/g,
																						'\n',
																					).replace(
																						/<\/?[^>]+(>|$)/g,
																						'',
																					)}
																					onChange={(
																						event,
																					) => {
																						handleChange(
																							event,
																						);
																						// event.target.style.height =
																						// 	'auto';
																						// event.target.style.height = `${event?.target?.scrollHeight}px`;
																					}}
																				// onLoad={(e) => {
																				// 	e.target.style.height =
																				// 		'auto';
																				// 	e.target.style.height = `${e?.target?.scrollHeight}px`;
																				// }}
																				// style={{
																				// 	height: 'auto',
																				// 	minHeight: '60px',
																				// }}
																				/>
																			</FormGroup>
																		</div>
																	</div>
																</div>
																{formState?.type_int == 'Pose' && (
																	<div className='col-12'>
																		<div className='d-flex'>
																			<div className='flex-shrink-0'>
																				<Icon
																					icon='Euro'
																					size='2x'
																					color='primary'
																				/>
																			</div>

																			<div className='flex-grow-1 ms-3'>
																				<div className='text-muted'>
																					Le client doit
																					payer :
																				</div>

																				<FormGroup
																					className='col-12'
																					id='amount_residual'>
																					<Input
																						onChange={
																							handleChange
																						}
																						//onBlur={handelBlurAmount}
																						value={
																							formState?.amount_residual
																						}
																						name='amount_residual'
																						type='number'
																						placeholder='0.0'
																					/>
																				</FormGroup>
																			</div>
																		</div>
																	</div>
																)}
															</>
														)}

														{ }
														{/* {userData?.role == 'admin' && (
													<div className='col-12'>
														<div className='d-flex align-items-center'>
															<div className='flex-grow-1 ms-3'>
																<div className='text-muted'>
																	Pièces jointes
																</div>
																<div className='fw-bold fs-5 mb-0'>
																	<Input
																		type='file'
																		name='attachmentsCommercial'
																		onChange={(e) => {
																			const newAttachments =
																				Array.from(
																					e?.target
																						?.files,
																				);
																			setAttachmentsRaport(
																				(
																					prevAttachments,
																				) => [
																					...prevAttachments,
																					...newAttachments,
																				],
																			);
																		}}
																		multiple
																		disabled={
																			userData?.role ==
																				'Technicien' ||
																			userData?.role?.toLocaleLowerCase() ==
																				'achat'
																		}
																	/>
																</div>
																<div className='row'>
																	{!!attachmentsCommercial?.length &&
																		attachmentsCommercial?.map(
																			(file, index) => {
																				console.log(file);
																				return (
																					<Attachements
																						file={file}
																						index={
																							index
																						}
																					/>
																				);
																			},
																		)}
																</div>
															</div>
														</div>
													</div>
												)} */}
													</div>
												</CardBody>
											</Card>
										</div>
										<div className='col-xl-6 col-md-12'>
											<Card shadow='sm' stretch>
												<CardHeader>
													<CardLabel icon='info' iconColor='primary'>
														<CardTitle>
															Informations d'intervention
														</CardTitle>
													</CardLabel>
												</CardHeader>
												<CardBody>
													<div className='row g-4'>
														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='Report'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Type d'intervention
																	</div>
																	<div className='fw-bold'>
																		{formState?.type_int}
																	</div>
																</div>
															</div>
														</div>
														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='MapsHomeWork'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Motif d'intervention
																	</div>
																	<div className='fw-bold'>
																		{formState?.motif}
																	</div>
																</div>
															</div>
														</div>
														<div className='col-12'>
															<div className='d-flex align-items-center'>
																<div className='flex-shrink-0'>
																	<Icon
																		icon='Person'
																		size='2x'
																		color='primary'
																	/>
																</div>
																<div className='flex-grow-1 ms-3'>
																	<div className='text-muted'>
																		Créé par
																	</div>
																	<div className='fw-bold'>
																		{
																			formState?.login_user
																				?.name
																		}
																	</div>
																</div>
															</div>
														</div>

														{formState?.state != 'draft' ? (
															!!formState?.employees_ids?.length && (
																<div className='col-12'>
																	<div className='d-flex align-items-center'>
																		<div className='flex-shrink-0'>
																			<Icon
																				icon='Today'
																				size='2x'
																				color='primary'
																			/>
																		</div>
																		<div className='flex-grow-1 ms-3'>
																			<div className='text-muted'>
																				Techniciens
																			</div>
																			<div className='fw-bold'>
																				{formState?.employees_ids?.map(
																					(
																						item,
																						index,
																					) => (
																						<>
																							<Button
																								key={
																									index
																								}
																								isOutline
																								icon='Person'
																								isDisable
																								color='primary'
																								className='me-2'>
																								{
																									item?.name
																								}
																							</Button>
																						</>
																					),
																				)}
																			</div>
																		</div>
																	</div>
																</div>
															)
														) : (
															<div className='row mt-5 d-flex justify-content-between'>
																<div className='col-auto'>
																	<Label>
																		Voitures et techniciens
																	</Label>
																	<div className='ms-3'>
																		{formState?.voitures
																			?.length > 0 ? (
																			formState?.voitures?.map(
																				(v) => (
																					<div>
																						{v?.name}
																						<div className='text-muted'>
																							{v
																								?.conducteur
																								?.length >
																								0 &&
																								v?.conducteur?.map(
																									(
																										technicien,
																									) => (
																										<span className='me-2'>
																											*{' '}
																											{
																												technicien?.name
																											}
																										</span>
																									),
																								)}
																						</div>
																					</div>
																				),
																			)
																		) : (
																			<div>
																				{
																					formState
																						?.voiture
																						?.name
																				}
																				<div className='text-muted'>
																					{formState
																						?.voiture
																						?.conducteur
																						?.length >
																						0 &&
																						formState?.voiture?.conducteur?.map(
																							(
																								technicien,
																							) =>
																								technicien?.name,
																						)}
																				</div>
																			</div>
																		)}
																	</div>
																</div>
																<div className='col-auto d-flex justify-content-end align-self-start'>
																	<Button
																		color={'primary'}
																		//className='w-auto'
																		isLight
																		onClick={() => {
																			setVoiturePopup(true);
																		}}>
																		<Icon
																			icon='CustomModifyCar'
																			size='2x'
																			className=''></Icon>{' '}
																		Ajouter voiture
																	</Button>
																</div>
															</div>
														)}

														{/* {formState?.state == 'draft' && (
													<FormGroup
														className='col-12'
														id='voiture'
														label='Voiture'>
														<Input
															onChange={handleChange}
															onFocus={handleChange}
															value={
																selectedVoiture?.name ||
																formState?.voiture?.name
															}
															name='voiture'
															autoComplete='off'
														/>
													</FormGroup>
												)} */}

														{userData?.role == 'Technicien' ||
															userData?.role?.toLocaleLowerCase() ==
															'achat' ? (
															<>
																<div className='col-lg-6'>
																	<div className='d-flex align-items-center'>
																		<div className='flex-shrink-0'>
																			<Icon
																				icon='Today'
																				size='2x'
																				color='primary'
																			/>
																		</div>
																		<div className='flex-grow-1 ms-3'>
																			<div className='text-muted'>
																				Date de début
																			</div>
																			<div className='fw-bold'>
																				{moment(
																					formState?.start_datetime,
																				).format(
																					moment.HTML5_FMT
																						.DATETIME_LOCAL,
																				)}
																			</div>
																		</div>
																	</div>
																</div>
																<div className='col-lg-6'>
																	<div className='d-flex align-items-center'>
																		<div className='flex-shrink-0'>
																			<Icon
																				icon='Today'
																				size='2x'
																				color='primary'
																			/>
																		</div>
																		<div className='flex-grow-1 ms-3'>
																			<div className='text-muted'>
																				Date de fin
																			</div>
																			<div className='fw-bold'>
																				{moment(
																					formState?.end_datetime,
																				).format(
																					moment.HTML5_FMT
																						.DATETIME_LOCAL,
																				)}
																			</div>
																		</div>
																	</div>
																</div>
															</>
														) : (
															<>
																<div className='col-12'>
																	<FormGroup
																		id='eventStart'
																		label={'Date de début'}>
																		<Input
																			name='start_datetime'
																			type='datetime-local'
																			autoComplete='off'
																			value={moment(
																				formState?.start_datetime,
																			).format(
																				moment.HTML5_FMT
																					.DATETIME_LOCAL,
																			)}
																			onChange={handleChange}
																			disabled={
																				userData?.role ==
																				'Technicien' ||
																				userData?.role?.toLocaleLowerCase() ==
																				'achat'
																			}
																		/>
																	</FormGroup>
																</div>
																<div className='col-12'>
																	<FormGroup
																		id='eventEnd'
																		label='Date de fin'>
																		<Input
																			name='end_datetime'
																			type='datetime-local'
																			value={moment(
																				formState?.end_datetime,
																			).format(
																				moment.HTML5_FMT
																					.DATETIME_LOCAL,
																			)}
																			onChange={handleChange}
																			disabled={
																				userData?.role ==
																				'Technicien' ||
																				userData?.role?.toLocaleLowerCase() ==
																				'achat'
																			}
																		/>
																	</FormGroup>
																</div>
															</>
														)}
													</div>
													{/* <div className='row mt-3'>
												<div className='flex-shrink-0 d-flex mb-2'>
													<div className='col-auto'>
														<Icon
															icon='AttachFile'
															size='2x'
															color='primary'
														/>
													</div>

													<div className='flex-grow-1 col-auto'>
														<div className='text-muted ms-3'>
															Pièces jointes
														</div>
													</div>
												</div>

												{formState?.attachment?.map((file) => {
													return (
														<Attachements
															file={file}
															index={file?.id}
														/>
													);
												})}
											</div> */}
													<div className='row g-4'>
														<div className='flex-shrink-0 d-flex mb-2'>
															<div className='col-auto'>
																<Icon
																	icon='AttachFile'
																	size='2x'
																	color='primary'
																/>
															</div>

															<div className='flex-grow-1 col-auto'>
																<div className='text-muted ms-3'>
																	Pièces jointes
																</div>
															</div>
														</div>
														{formState?.state != 'done' &&
															userData?.role != 'Technicien' &&
															userData?.role?.toLocaleLowerCase() !=
															'achat' && (
																<div className='col-12'>
																	<Input
																		type='file'
																		autoComplete='photo'
																		multiple
																		onChange={(e) => {
																			const newAttachments =
																				Array.from(
																					e?.target
																						?.files,
																				);
																			setAttachmentsCommercial(
																				(
																					prevAttachments,
																				) => [
																						...prevAttachments,
																						...newAttachments,
																					],
																			);
																		}}
																	// onChange={
																	// 	handleChangeAttachements
																	// }
																	// disabled={
																	// 	(userData?.role !=
																	// 		'Technicien' &&
																	// 		userData?.role?.toLocaleLowerCase() !=
																	// 			'achat') ||
																	// 	formState?.state ==
																	// 		'done'
																	// }
																	/>
																</div>
															)}
														<div className='row'>
															{attachmentsCommercial?.length > 0 &&
																userData?.role != 'Technicien' &&
																userData?.role?.toLocaleLowerCase() !=
																'achat' &&
																formState?.state != 'done'
																? attachmentsCommercial?.map(
																	(file, index) => (
																		<Attachements
																			file={file}
																			index={index}
																			deleteImage={() => {
																				deleteCommercialImage(
																					index,
																					file,
																				);
																			}}
																		/>
																	),
																)
																: attachmentsCommercial?.map(
																	(file, index) => (
																		<Attachements
																			file={file}
																			index={index}
																		/>
																	),
																)}
														</div>
													</div>
												</CardBody>
											</Card>
										</div>
									</div>
								</CardTabItem>
								<CardTabItem id='Devis' title='Devis'>
									<div className='d-flex justify-content-end '>
										{formState?.state != 'cancel' && (
											<Button
												className=''
												color='success'
												icon='PostAdd'
												onClick={() => setConfirmCreateDevisPopup(true)}>
												Créer un devis
											</Button>
										)}
										<Button
											className='w-auto ms-2'
											color='primary'
											icon='PostAdd'
											hoverShadow='none'
											onClick={() => setConfirmDecharge(true)}>
											Créer une décharge
										</Button>
									</div>
									{userData?.role != 'Technicien' &&
										userData?.role?.toLocaleLowerCase() != 'achat' && (
											<div className='col-lg-6 mb-3' ref={ref}>
												<FormGroup className='autocomplete'>
													<Input
														placeholder='🔎︎ Rechercher par devis, client ...'
														onChange={handleDevisChange}
														onFocus={handleDevisChange}
														value={devisInputSearch}
														name='name'
														autoComplete='off'
													/>
													{openList && devisIsLoading ? (
														<div
															id='myInputautocomplete-list'
															className='autocomplete-items'>
															<div className='body'>
																<div tag={'button'}>
																	<Spinner isSmall isGrow />{' '}
																	<Spinner isSmall isGrow />{' '}
																	<Spinner isSmall isGrow />
																</div>
															</div>
														</div>
													) : (
														!!filterDevisResult?.length && (
															<div
																id='myInputautocomplete-list'
																className='autocomplete-items'>
																<div className='body'>
																	{filterDevisResult?.map(
																		(item) => (
																			<div
																				className='d-flex g-1'
																				key={item?.id}
																				onClick={() => {
																					handelSelectDevis(
																						item,
																					);
																				}}>
																				<div className='w-auto'>
																					<small
																						className={` px-2 `}>
																						<Icon
																							icon='Info'
																							className='me-1'
																							size={
																								'lg'
																							}
																						/>
																						<span className='text-dark'>
																							{
																								item?.name
																							}
																						</span>
																					</small>
																				</div>
																				<div className='w-auto'>
																					<small
																						className={` px-2 `}>
																						<Icon
																							icon='Person'
																							className='me-1'
																							size={
																								'lg'
																							}
																						/>
																						<span className='text-dark'>
																							{
																								item?.nom_client
																							}
																						</span>
																					</small>
																				</div>
																				{(!!item?.phone_client ||
																					!!item?.mobile_client) && (
																						<div className='w-auto '>
																							<small
																								className={`  px-2   `}>
																								<Icon
																									icon='LocalPhone'
																									className='me-1'
																									size={
																										'lg'
																									}
																								/>
																								<span className='text-dark'>
																									{
																										item?.phone_client
																									}{' '}
																									{
																										item?.mobile_client
																									}
																								</span>
																							</small>
																						</div>
																					)}

																				<div className='w-auto '>
																					<small
																						className={`  px-2   `}>
																						<Icon
																							icon='Today'
																							className='me-1'
																							size={
																								'lg'
																							}
																						/>
																						<span className='text-dark'>
																							{moment(
																								item?.create_date,
																							).format(
																								'DD/MM/yyyy',
																							)}
																						</span>
																					</small>
																				</div>
																			</div>
																		),
																	)}
																</div>
															</div>
														)
													)}
												</FormGroup>
											</div>
										)}
									<div className='row mt-3'>
										{!!devisDatas?.length &&
											devisDatas?.map((devis) => {
												return (
													<div
														className='col-lg-4 col-md-6 col-sm-12'
														key={devis?.id}>
														<Card isCompact>
															<CardHeader>
																<CardLabel>
																	<Label>
																		Devis - {t(devis?.state)}
																	</Label>
																</CardLabel>
																{userData?.role != 'Technicien' &&
																	userData?.role?.toLocaleLowerCase() !=
																	'achat' && (
																		<CardActions>
																			<Icon
																				className='cursor-pointer'
																				icon='Delete'
																				color='danger'
																				size={'2x'}
																				onClick={() => {
																					setFormState({
																						...formState,
																						devis_liste:
																							formState?.devis_liste?.filter(
																								(
																									item,
																								) =>
																									item !=
																									devis?.id,
																							),
																					});
																					setFacturesDatas(
																						facturesDatas?.filter(
																							(
																								facture,
																							) =>
																								facture?.id !=
																								devis?.invoice_id,
																						),
																					);
																				}}></Icon>
																		</CardActions>
																	)}
															</CardHeader>
															<CardBody>
																<DevisCard
																	card={devis}
																	loadData={loadDevis}
																/>
															</CardBody>
														</Card>
													</div>
												);
											})}
									</div>
									<div className='row mt-3'>
										{!!facturesDatas?.length &&
											facturesDatas?.map((facture) => {
												return (
													<div
														className='col-lg-4 col-md-6 col-sm-12'
														key={facture?.id}>
														<Card isCompact>
															<CardHeader>
																<CardLabel>
																	<Label>
																		Facture -{' '}
																		{t(facture?.state)}
																	</Label>
																</CardLabel>
															</CardHeader>
															<CardBody>
																<FactureCard
																	card={facture}
																	loadFactures={loadDevis}
																/>
															</CardBody>
														</Card>
													</div>
												);
											})}
									</div>
								</CardTabItem>
								<CardTabItem id='tab-demo' title='Rapport'>
									{formState?.employees_ids
										?.map((item) => item?.id)
										?.includes(userData?.employee) ||
										userData?.role == 'Admin' ||
										formState?.state == 'done' ||
										formState?.state == 'cancel' ? (
										<div className='row'>
											{!(
												(userData?.role?.toLowerCase() != 'technicien' &&
													userData?.role?.toLocaleLowerCase() !=
													'achat' &&
													userData?.role?.toLocaleLowerCase() !=
													'admin') ||
												formState?.state == 'done'
											) && (
													<Alert color='danger' isLight isDismissible>
														S'il y a un paiement, veuillez le saisir dans la
														section dédiée.{' '}
														<Button
															color='danger'
															isLight
															className='w-auto mt-2'
															icon={'OpenInNew'}
															onClick={() => {
																setActiveTabControled(3);
															}}>
															Voir paiement
														</Button>
													</Alert>
												)}
											<Card shadow='sm'>
												<CardHeader>
													<CardLabel icon='Article' iconColor='primary'>
														<CardTitle>
															Compte rendu{' '}
															<small>(Obligatoire)</small>
															{/* <span style={{ color: 'red' }}>*</span> */}
														</CardTitle>
													</CardLabel>

													<CardActions>
														{formState?.state != 'done' &&
															formState?.state != 'cancel' &&
															formState?.type_int == 'Pose' &&
															!!devisDatas?.length && (
																<Button
																	className='w-auto ms-2 '
																	color='warning'
																	isLight
																	icon='PostAdd'
																	onClick={() =>
																		setConfirmCreatePVPopup(
																			true,
																		)
																	}>
																	Créer un PV de réception
																</Button>
															)}
														{formState.state == 'done' && (
															<Button
																color='primary'
																isLight
																icon='Download'
																size={'2x'}
																onClick={() => {
																	window.open(
																		getReportPlanning(
																			userData,
																			id,
																		),
																		'_blank',
																	);
																}}>
																Télécharger rapport
															</Button>
														)}
													</CardActions>
												</CardHeader>

												<CardBody>
													{!(
														(userData?.role != 'Technicien' &&
															userData?.role?.toLocaleLowerCase() !=
															'achat' &&
															userData?.role?.toLocaleLowerCase() !=
															'admin') ||
														formState?.state == 'done'
													) && (
															<MotifsRapports
																stateForm={stateForm}
																setStateForm={setStateForm}
															/>
														)}

													{(userData?.role != 'Technicien' &&
														userData?.role?.toLocaleLowerCase() !=
														'achat' &&
														userData?.role?.toLocaleLowerCase() !=
														'admin') ||
														formState?.state == 'done' ? (
														React.createElement('div', {
															dangerouslySetInnerHTML: {
																__html: (
																	formState?.Rapport || ''
																).replace(/\n/g, '<br />'),
															},
														})
													) : (
														<>
															{!!autoGeneratedContent && (
																<div className='bg-l10-brand-two rounded-1 p-3 row d-flex justify-content-between'>
																	<div className='col-9'>
																		{' '}
																		{React.createElement(
																			'div',
																			{
																				dangerouslySetInnerHTML:
																				{
																					__html: (
																						autoGeneratedContent ||
																						''
																					).replace(
																						/\n/g,
																						'<br />',
																					),
																				},
																			},
																		)}
																	</div>
																	<div className='col-auto'>
																		<Button
																			color='primary'
																			icon='CreditCard'
																			isLight
																			isLink={true}
																			tag='a'
																			target='_blank'
																			onClick={() =>
																				setStateForm({})
																			}>
																			Effacer
																		</Button>
																	</div>
																</div>
															)}

															<Label className='ms-3 mt-3'>
																Remarques
															</Label>
															<Textarea
																name='Rapport'
																placeholder=''
																id='remarque'
																value={userInput
																	?.replace('<p>', '')
																	.replace('</p>', '')}
																onChange={(e) => {
																	handleUserInputChange(e);

																	e.target.style.height = 'auto';
																	e.target.style.height = `${e?.target?.scrollHeight}px`;
																}}></Textarea>
														</>
													)}
												</CardBody>
												<CardHeader>
													<CardLabel
														icon='FilePresent'
														iconColor='primary'>
														<CardTitle>
															Pièces jointes{' '}
															<small>(Obligatoire)</small>
														</CardTitle>
													</CardLabel>
												</CardHeader>
												<CardBody>
													<div className='row'>
														<div className='col-lg-12'>
															<div className='row g-4'>
																{formState?.state != 'done' &&
																	(userData?.role ==
																		'Technicien' ||
																		userData?.role?.toLocaleLowerCase() ==
																		'admin' ||
																		userData?.role?.toLocaleLowerCase() ==
																		'achat' ||
																		userData?.role?.toLocaleLowerCase() ==
																		'superadmin') && (
																		<>
																			<div className='col-auto'>
																				<Input
																					type='file'
																					autoComplete='photo'
																					name='attachments'
																					multiple
																					onChange={(
																						e,
																					) => {
																						const newAttachments =
																							Array.from(
																								e
																									?.target
																									?.files,
																							);
																						setUploadSpinner(
																							true,
																						);
																						uploadAttachementsTechnicien(
																							userData?.password,
																							formState?.id,
																							newAttachments,
																							(
																								result,
																							) => {
																								const newUploadedAtttachements =
																									[
																										...attachmentsRaport,
																										...newAttachments.map(
																											(
																												file,
																											) => ({
																												id: result
																													?.data
																													?.attachment[0],
																												file: file,
																											}),
																										),
																									];
																								setAttachmentsRaport(
																									newUploadedAtttachements,
																								);
																								event.attachment_report =
																									newUploadedAtttachements;
																								setUploadSpinner(
																									false,
																								);
																							},
																							(
																								error,
																							) => {
																								setError(
																									error,
																								);
																								setUploadSpinner(
																									false,
																								);
																							},
																						);
																					}}
																				/>
																			</div>
																			<Button
																				className='w-auto'
																				isLight
																				icon='FileUpload'
																				color={
																					!!uploadSpinner
																						? COLORS
																							.DANGER
																							.name
																						: COLORS
																							.SUCCESS
																							.name
																				}
																				isDisable>
																				{!!uploadSpinner
																					? 'En cours de téléchargement...'
																					: attachmentsRaport?.length >
																						0
																						? 'Toutes les images ont été téléchargées'
																						: 'Aucune image'}
																			</Button>
																		</>
																	)}
																<div className='row g-4'>
																	{attachmentsRaport?.length >
																		0 &&
																		(userData?.role ==
																			'Technicien' ||
																			userData?.role?.toLocaleLowerCase() ==
																			'admin' ||
																			userData?.role?.toLocaleLowerCase() ==
																			'achat' ||
																			userData?.role?.toLocaleLowerCase() ==
																			'superadmin') &&
																		formState?.state != 'done'
																		? attachmentsRaport?.map(
																			(file, index) => (
																				<Attachements
																					file={file}
																					index={
																						index
																					}
																					deleteImage={() => {
																						deleteRaportImage(
																							index,
																							file,
																						);
																					}}
																				/>
																			),
																		)
																		: userData?.role?.toLocaleLowerCase() ==
																			'admin' ||
																			userData?.role?.toLocaleLowerCase() ==
																			'superadmin'
																			? attachmentsRaport?.map(
																				(file, index) => (
																					<Attachements
																						file={file}
																						index={
																							index
																						}
																						deleteImage={() => {
																							deleteRaportImage(
																								index,
																								file,
																							);
																						}}
																					/>
																				),
																			)
																			: attachmentsRaport?.map(
																				(file, index) => (
																					<Attachements
																						file={file}
																						index={
																							index
																						}
																					/>
																				),
																			)}
																</div>
															</div>
														</div>
													</div>
												</CardBody>
											</Card>
											{formState?.state == 'done' && (
												<Card className='cursor-pointer'>
													<CardHeader
														onClick={() =>
															setOpenRapport(!openRapport)
														}>
														<CardLabel
															icon='PostAdd'
															iconColor='primary'>
															<CardTitle>
																Rapport supplémentaire
															</CardTitle>
														</CardLabel>
													</CardHeader>

													{openRapport && (
														<>
															<CardBody>
																{(userData?.role == 'Technicien' ||
																	userData?.role?.toLocaleLowerCase() ==
																	'achat' ||
																	userData?.role?.toLocaleLowerCase() ==
																	'admin') &&
																	formState?.state == 'done' ? (
																	<Textarea
																		name='rapport_supp'
																		placeholder='Remarques ......'
																		id='rapport_supp'
																		value={formState?.rapport_supp
																			?.replace('<p>', '')
																			.replace('</p>', '')}
																		onChange={(e) => {
																			handleChange(e);
																			updateSlotPlanning(
																				userData?.password,
																				{
																					id: formState?.id,
																					rapport_supp:
																						e.target
																							.value,
																				},
																				() => {
																					event.rapport_supp =
																						e.target.value;
																				},
																			);
																			e.target.style.height =
																				'auto';
																			e.target.style.height = `${e?.target?.scrollHeight}px`;
																		}}></Textarea>
																) : (
																	React.createElement('div', {
																		dangerouslySetInnerHTML: {
																			__html: (
																				formState?.rapport_supp ||
																				''
																			).replace(
																				/\n/g,
																				'<br />',
																			),
																		},
																	})
																)}
															</CardBody>
															<CardHeader>
																<CardLabel
																	icon='FilePresent'
																	iconColor='primary'>
																	<CardTitle>
																		Pièces jointes
																	</CardTitle>
																</CardLabel>
															</CardHeader>
															<CardBody>
																<div className='row'>
																	<div className='col-lg-12'>
																		<div className='row g-4'>
																			{formState?.state ==
																				'done' &&
																				(userData?.role ==
																					'Technicien' ||
																					userData?.role?.toLocaleLowerCase() ==
																					'achat' ||
																					userData?.role?.toLocaleLowerCase() ==
																					'admin') && (
																					<>
																						<div className='col-auto'>
																							<Input
																								type='file'
																								autoComplete='photo'
																								name='attachments'
																								multiple
																								onChange={(
																									e,
																								) => {
																									const newAttachments =
																										Array.from(
																											e
																												?.target
																												?.files,
																										);
																									setUploadSpinner(
																										true,
																									);

																									uploadAttachementsSuppTechnicien(
																										userData?.password,
																										formState?.id,
																										newAttachments,
																										(
																											result,
																										) => {
																											const newUploadedAtttachements =
																												[
																													...attachmentsRaportSupp,
																													...newAttachments.map(
																														(
																															file,
																														) => ({
																															id: result
																																?.data
																																?.attachment[0],
																															file: file,
																														}),
																													),
																												];
																											setAttachmentsRaportSupp(
																												newUploadedAtttachements,
																											);
																											event.attachment_report_supp =
																												newUploadedAtttachements;
																											setUploadSpinner(
																												false,
																											);
																										},
																										(
																											error,
																										) => {
																											setError(
																												error,
																											);
																											setUploadSpinner(
																												false,
																											);
																										},
																									);
																								}}
																							/>
																						</div>
																						<Button
																							className='w-auto'
																							isLight
																							icon='FileUpload'
																							color={
																								!!uploadSpinner
																									? COLORS
																										.DANGER
																										.name
																									: COLORS
																										.SUCCESS
																										.name
																							}
																							isDisable>
																							{!!uploadSpinner
																								? 'En cours de téléchargement...'
																								: attachmentsRaportSupp?.length >
																									0
																									? 'Toutes les images ont été téléchargées'
																									: 'Aucune image'}
																						</Button>
																					</>
																				)}
																			<div className='row g-4'>
																				{attachmentsRaportSupp?.length >
																					0 &&
																					(userData?.role ==
																						'Technicien' ||
																						userData?.role?.toLocaleLowerCase() ==
																						'achat' ||
																						userData?.role?.toLocaleLowerCase() ==
																						'admin') &&
																					formState?.state ==
																					'done'
																					? attachmentsRaportSupp?.map(
																						(
																							file,
																							index,
																						) => (
																							<Attachements
																								file={
																									file
																								}
																								index={
																									index
																								}
																								deleteImage={() => {
																									deleteRaportImageSupp(
																										index,
																										file,
																									);
																								}}
																							/>
																						),
																					)
																					: attachmentsRaportSupp?.map(
																						(
																							file,
																							index,
																						) => (
																							<Attachements
																								file={
																									file
																								}
																								index={
																									index
																								}
																							/>
																						),
																					)}
																			</div>
																		</div>
																	</div>
																</div>
															</CardBody>
															<CardFooter>
																<CardFooterRight>
																	{(userData?.role?.toLowerCase() ==
																		'technicien' ||
																		userData?.role?.toLowerCase() ==
																		'achat' ||
																		userData?.role?.toLowerCase() ==
																		'admin') &&
																		formState?.state ==
																		'done' && (
																			<Button
																				color='primary'
																				className='w-auto'
																				type='submit'
																				onClick={() => {
																					uploadSpinner
																						? setUploadPopup(
																							"Merci de patienter pendant la sauvegarde des photos, ne fermez pas l'application.",
																						)
																						: handelUploadRapportSupp();
																				}}
																				// disabled={
																				// 	userData?.role == 'Technicien' &&
																				// 	(formState?.Rapport == '' || !attachmentsRaport?.length)
																				// }
																				disabled={
																					isLoading
																				}>
																				{isLoading && (
																					<Spinner
																						isSmall
																						inButton
																					/>
																				)}
																				{isLoading
																					? 'En cours'
																					: 'Sauvegarder'}
																			</Button>
																		)}
																</CardFooterRight>
															</CardFooter>
														</>
													)}
												</Card>
											)}
										</div>
									) : (
										<div>
											<Card shadow={'none'}>
												<CardBody className='d-flex text-center align-items-center'>
													<div className='col-6'>
														<img
															src={noTasks}
															alt='eneme'
															className='w-75'
														/>
													</div>
													<div className='fw-semibold fs-5'>
														<div>
															Le technicien est en train de préparer
															son rapport.
														</div>
														<div>
															Veuillez réessayer après la fin de
															l'intervention.
														</div>
													</div>
												</CardBody>
											</Card>
										</div>
									)}
								</CardTabItem>
								<CardTabItem id='paiement' title='Paiement'>
									<PaiementsCard
										facturesDatas={facturesDatas[0]}
										event={event}
										setFormState={setFormState}
									/>
								</CardTabItem>
								{!(
									userData?.role?.toLowerCase() == 'technicien' ||
									userData?.role?.toLowerCase() == 'achat'
								) && (
										<CardTabItem id='tab-suivi' title='Chronologie'>
											<MailMessageContextProvider>
												<Chronologies event={event} />
											</MailMessageContextProvider>
										</CardTabItem>
									)}
							</Card>
						</ModalBody>

						<ModalFooter className='px-4 pb-4'>
							{formState?.state != 'done' && formState?.state != 'cancel' && (
								<>
									{(userData?.role?.toLowerCase() == 'technicien' ||
										userData?.role?.toLowerCase() == 'achat' ||
										userData?.role?.toLowerCase() == 'admin') && (
											<Button
												color='info'
												className='w-auto'
												type='submit'
												onClick={() => {
													uploadSpinner
														? setUploadPopup(
															"Merci de patienter pendant la sauvegarde des photos, ne fermez pas l'application.",
														)
														: handelSubmit();
												}}
												// disabled={
												// 	userData?.role == 'Technicien' &&
												// 	(formState?.Rapport == '' || !attachmentsRaport?.length)
												// }
												disabled={isLoading}>
												{isLoading && <Spinner isSmall inButton />}
												{isLoading ? 'En cours' : 'Terminer'}
											</Button>
										)}

									{userData?.role?.toLowerCase() != 'technicien' &&
										userData?.role?.toLowerCase() != 'achat' && (
											<Button
												color='primary'
												className='w-auto'
												onClick={() => setUpdateIntervention(true)}
												disabled={isLoading}>
												{isLoading && <Spinner isSmall inButton />}
												{isLoading ? 'En cours' : 'Enregistrer'}
											</Button>
										)}
								</>
							)}
						</ModalFooter>
					</>
				)}
				{/* {!!error && (
					<Alert color='danger' icon='report' isLight className='mx-4 mb-4'>
						{!!error?.message ? error?.message : error}
					</Alert>
				)} */}
				{!!obligation && (
					<StatusPopup
						icon='info'
						color='info'
						title={obligation}
						// label={obligation}
						setOpen={setObligation}
					/>
				)}
				{!!error && <ErrorPopup error={error} setOpen={setError} />}
				{!!uploadPopup && (
					<StatusPopup
						icon='FileUpload'
						color='warning'
						title={'Sauvegarde des Photos en Cours !'}
						label={uploadPopup}
						setOpen={setUploadPopup}
					/>
				)}
				{!!success && (
					<StatusPopup
						icon='CheckCircleOutline'
						color='success'
						label={success}
						setOpen={(param) => {
							setSuccess(param);
							setEditModalStatus(param);
						}}
					/>
				)}
			</Modal>
			{/* {searchModalStatus && (
				<SearchPopUp
					setSearchModalStatus={() => setSearchModalStatus(false)}
					filterResult={filterResult || {}}
					valueInput={formState}
					curentInput={curentInput}
					handelChange={handleChange}
					handelSelect={handelSelect}
				/>
			)} */}
			{updateClientModal && (
				<SearchClient
					setCreateClientModalStatus={setUpdateClientModal}
					handelSelect={handelSelect}
					data={formState?.partner_id}
					handleUpdate={handleUpdate}
				/>
			)}
			{editDevisModalStatus && (
				<DevisLinesContextProvider>
					<DevisPopUp
						card={newDevisData}
						setEditModalStatus={(param) => {
							setEditDevisModalStatus(param);
							//getInterventions();
							//setEditModalStatus(false);
						}}
						loadData={loadDevis}
					/>
				</DevisLinesContextProvider>
			)}
			{confirmDeletePopup && (
				<ConfirmationPopup
					title='Annuler cette intervention ?'
					handleConfirm={handleDeleteIntervention}
					setOpen={setConfirmDeletePopup}
				/>
			)}
			{confirmCreateDevisPopup && (
				<ConfirmationPopup
					title='Créer un devis ?'
					handleConfirm={handleCreateDevis}
					setOpen={setConfirmCreateDevisPopup}
				/>
			)}

			{nouvelleIntervention && (
				<InterventionCreatePopUp
					setCreateModalStatus={() => setNouvelleIntervention(false)}
					newData={newData}
					getInterventions={getInterventions}
					setEditModalStatus={setEditModalStatus}
				/>
			)}
			{dupliquerIntervention && (
				<InterventionCreatePopUp
					setCreateModalStatus={() => setDupliquerIntervention(false)}
					newData={dupliquerData}
					getInterventions={getInterventions}
					setEditModalStatus={setEditModalStatus}
				/>
			)}
			{/* {updateIntervention && (
				<ConfirmationPopup
					title='Modifier cette intervention ?'
					handleConfirm={handelUpdateIntervention}
					setOpen={setUpdateIntervention}
				/>
			)} */}
			{updateIntervention && (
				<NavigatePopup
					icon='Settings'
					color='primary'
					setOpen={setUpdateIntervention}
					title='Modification'
					label='Voulez-vous modifier cette intervention ?'
					btn1='Confirmer'
					btn2='Annuler'
					fn1={() => {
						handelUpdateIntervention();
						setUpdateIntervention(false);
					}}
					fn2={() => setUpdateIntervention(false)}
				/>
			)}
			{checkPaiement && (
				<NavigatePopup
					icon='Euro'
					color='primary'
					setOpen={setCheckPaiement}
					title='Paiement'
					label='Y a-t-il un paiement effectué dans cette intervention ?'
					btn1='Oui'
					btn2='Non'
					fn1={() => {
						setActiveTabControled(3);
						setCheckPaiement(false);
					}}
					fn2={() => {
						//setFormState({ ...formState, paiement: true });
						handelSubmit(true);
						setCheckPaiement(false);
					}}
				/>
			)}

			{confirmCreatePVPopup && (
				<PvReceptionPopup
					setOpen={setConfirmCreatePVPopup}
					planning={event}
					setAttachmentsRaport={setAttachmentsRaport}
				/>
			)}

			{confirmDecharge && (
				<DechargeDevis
					setOpen={setConfirmDecharge}
					devisAccepte={devisAccepte}
					setAttachmentsRaport={setAttachmentsRaport}
					planning={event}
				/>
			)}

			{!!voiturePopup && (
				<VoiturePopup
					setVoiturePopup={setVoiturePopup}
					formState={formState}
					setFormState={setFormState}
				/>
			)}
			{paymentModalStatus && (
				<PaymentPopup
					setPaymentModalStatus={setPaymentModalStatus}
					amountResidual={facturesDatas[0]?.amount_residual}
					invoiceId={facturesDatas[0]?.id}
					Invoice={facturesDatas[0]}
				/>
			)}
			{!!editModalTask && (
				<ActivityCreatePopup
					res_id={event}
					setEditModalStatus={setEditModalTask}
					client={event?.partner_id}
				/>
			)}

			{/* {!!error && <ConfirmationPopup title={error} setOpen={setError} />} */}
		</>
	);
};

InterventionPopUp.propTypes = {
	setEditModalStatus: PropTypes.func.isRequired,
	// event: PropTypes.object,
	/* selectedValue:PropTypes.object */
};

export default InterventionPopUp;
